import * as React from "react";
import { AnchorOutlineButton, LinkOutlineButton } from "../../components/OutlineButton";
import "./JoinUsPanel.scss";

interface IJoinUsPanelProps {}

export const JoinUsPanel: React.FunctionComponent<IJoinUsPanelProps> = (
  props
) => {
  return (
    <div className="JoinUsPanel">
      <div>
        <h1>Join us</h1>
        <h3>Outdoor Booth in Central Plaza</h3>
        <h4>Las Vegas Convention Center</h4>
        <h2>January 5–8 2022 &nbsp;|&nbsp; Booth CP-14</h2>
        <div className="JoinUsPanel__buttons">
          <LinkOutlineButton className="yellow" text="Explore Booth Demos" to="/media/booth" />
          <AnchorOutlineButton className="yellow" text="View Booth Location" to="https://jd-ces-2022.s3.amazonaws.com/media-resources/ces2022_exhibit_location.pdf" />
        </div>
      </div>
    </div>
  );
};
